// Updated with M5 support - v1.1
var product_data = [
  {
    "id": 44613585731748,
    "dockType": "Single Dock",
    "years": "2016-2020",
    "model": "Pro",
    "sizes": '13, 15, 16',
    "processor": ["Intel"],
    "pre_order": false,
    "warningText": false,
    "warningTouchbar": true,
    "discontinued": true
  },
  {
    "id": 44613585928356,
    "dockType": "1x Monitor",
    "years": "2016-2020",
    "model": "Pro",
    "sizes": '13, 15, 16',
    "processor": ["Intel"],
    "pre_order": false,
    "warningText": false,
    "warningTouchbar": true,
    "discontinued": true
  },
  {
    "id": 44613586124964,
    "dockType": "2x Monitor",
    "years": "2016-2020",
    "model": "Pro",
    "sizes": '13, 15, 16',
    "processor": ["Intel"],
    "pre_order": false,
    "warningText": false,
    "warningTouchbar": true,
    "discontinued": true
  },
  {
    "id": 44613585731748,
    "dockType": "Single Dock",
    "years": "2016-2020",
    "model": "Pro",
    "sizes": "13",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": true,
    "discontinued": true
  },
  {
    "id": 44613585928356,
    "dockType": "1x Monitor",
    "years": "2016-2020",
    "model": "Pro",
    "sizes": "13",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": true,
    "discontinued": true
  },
  {
    "id": 44613586256036,
    "dockType": "2x Monitor M1/M2",
    "years": "2016-2020",
    "model": "Pro",
    "sizes": "13",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": false,
    "discontinued": true
  },
  {
    "id": 44613585731748,
    "dockType": "Single Dock",
    "years": "2022",
    "model": "Pro",
    "sizes": "13",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": true
  },
  {
    "id": 44613585928356,
    "dockType": "1x Monitor",
    "years": "2022",
    "model": "Pro",
    "sizes": "13",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": true
  },
  {
    "id": 44613586256036,
    "dockType": "2x Monitor M1/M2",
    "years": "2022",
    "model": "Pro",
    "sizes": "13",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585764516,
    "dockType": "Single Dock",
    "years": "2018-2020",
    "model": "Air",
    "sizes": "13",
    "processor": ["Intel"],
    "pre_order": false,
    "warningText": false,
    "discontinued": true
  },
  {
    "id": 44613585961124,
    "dockType": "1x Monitor",
    "years": "2018-2020",
    "model": "Air",
    "sizes": "13",
    "processor": ["Intel"],
    "pre_order": false,
    "warningText": false,
    "discontinued": true
  },
  {
    "id": 44613586157732,
    "dockType": "2x Monitor",
    "years": "2018-2020",
    "model": "Air",
    "sizes": "13",
    "processor": ["Intel"],
    "pre_order": false,
    "warningText": false,
    "discontinued": true
  },
  {
    "id": 44613585764516,
    "dockType": "Single Dock",
    "years": "2018-2020",
    "model": "Air",
    "sizes": "13",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": true,
    "discontinued": true
  },
  {
    "id": 44613585961124,
    "dockType": "1x Monitor",
    "years": "2018-2020",
    "model": "Air",
    "sizes": "13",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": true,
    "discontinued": true
  },
  {
    "id": 44613586288804,
    "dockType": "2x Monitor M1/M2",
    "years": "2018-2020",
    "model": "Air",
    "sizes": "13",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": false,
    "discontinued": true
  },
  {
    "id": 44613585797284,
    "dockType": "Single Dock",
    "years": "2021",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585993892,
    "dockType": "1x Monitor",
    "years": "2021",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586190500,
    "dockType": "2x Monitor",
    "years": "2021",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585797284,
    "dockType": "Single Dock",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585993892,
    "dockType": "1x Monitor",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586190500,
    "dockType": "2x Monitor",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585830052,
    "dockType": "Single Dock",
    "years": "2023",
    "model": "Pro",
    "sizes": "16",
    "processor": ["M2", "M3"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586026660,
    "dockType": "1x Monitor",
    "years": "2023",
    "model": "Pro",
    "sizes": "16",
    "processor": ["M2", "M3"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586223268,
    "dockType": "2x Monitor",
    "years": "2023",
    "model": "Pro",
    "sizes": "16",
    "processor": ["M2", "M3"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585830052,
    "dockType": "Single Dock",
    "years": "2021",
    "model": "Pro",
    "sizes": "16",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586026660,
    "dockType": "1x Monitor",
    "years": "2021",
    "model": "Pro",
    "sizes": "16",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586223268,
    "dockType": "2x Monitor",
    "years": "2021",
    "model": "Pro",
    "sizes": "16",
    "processor": ["M1"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585862820,
    "dockType": "Single Dock",
    "years": "2022",
    "model": "Air",
    "sizes": "13",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": true
  },
  {
    "id": 44613586059428,
    "dockType": "1x Monitor",
    "years": "2022",
    "model": "Air",
    "sizes": "13",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": true
  },
  {
    "id": 44613586387108,
    "dockType": "2x Monitor M1/M2",
    "years": "2022",
    "model": "Air",
    "sizes": "13",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585895588,
    "dockType": "Single Dock",
    "years": "2023",
    "model": "Air",
    "sizes": "15",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": true
  },
  {
    "id": 44613586092196,
    "dockType": "1x Monitor",
    "years": "2023",
    "model": "Air",
    "sizes": "15",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": true
  },
  {
    "id": 44613586419876,
    "dockType": "2x Monitor M1/M2",
    "years": "2023",
    "model": "Air",
    "sizes": "15",
    "processor": ["M2"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585797284,
    "dockType": "Single Dock",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M3"],
    "sub_processor": ["Base"],
    "pre_order": false,
    "warningText": true
  },
  {
    "id": 44613585993892,
    "dockType": "1x Monitor",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M3"],
    "sub_processor": ["Base"],
    "pre_order": false,
    "warningText": true
  },
  {
    "id": 44716290244772,
    "dockType": "2x Monitor M3",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M3"],
    "sub_processor": ["Base"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585797284,
    "dockType": "Single Dock",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M3"],
    "sub_processor": ["Pro", "Max"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585993892,
    "dockType": "1x Monitor",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M3"],
    "sub_processor": ["Pro", "Max"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586190500,
    "dockType": "2x Monitor",
    "years": "2023",
    "model": "Pro",
    "sizes": "14",
    "processor": ["M3"],
    "sub_processor": ["Pro", "Max"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 45405575217316,
    "dockType": "2x Monitor M1/M2",
    "years": "2024",
    "model": "Air",
    "sizes": "15",
    "processor": ["M3"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586092196,
    "dockType": "1x Monitor",
    "years": "2024",
    "model": "Air",
    "sizes": "15",
    "processor": ["M3"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585895588,
    "dockType": "Single Dock",
    "years": "2024",
    "model": "Air",
    "sizes": "15",
    "processor": ["M3"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 45405552509092,
    "dockType": "2x Monitor M1/M2",
    "years": "2024",
    "model": "Air",
    "sizes": "13",
    "processor": ["M3"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586059428,
    "dockType": "1x Monitor",
    "years": "2024",
    "model": "Air",
    "sizes": "13",
    "processor": ["M3"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585862820,
    "dockType": "Single Dock",
    "years": "2024",
    "model": "Air",
    "sizes": "13",
    "processor": ["M3"],
    "pre_order": false,
    "warningText": false
  },
  // 14-inch M4 Pro and Max entries
  {
      "id": 44613585797284,  // You'll need to update with actual variant ID
      "dockType": "Single Dock",
      "years": "2024",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M4"],
      "sub_processor": ["Pro", "Max"],
      "pre_order": false,
      "warningText": false
  },
  {
      "id": 44613585993892,  // You'll need to update with actual variant ID
      "dockType": "1x Monitor",
      "years": "2024",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M4"],
      "sub_processor": ["Pro", "Max"],
      "pre_order": false,
      "warningText": false
  },
  {
      "id": 44613586190500,  // You'll need to update with actual variant ID
      "dockType": "2x Monitor",
      "years": "2024",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M4"],
      "sub_processor": ["Pro", "Max"],
      "pre_order": false,
      "warningText": false
  },


  // 16-inch M4 entries (no sub_processor needed - Pro/Max have no difference)
  {
      "id": 44613585830052,  // You'll need to update with actual variant ID
      "dockType": "Single Dock",
      "years": "2024",
      "model": "Pro",
      "sizes": "16",
      "processor": ["M4"],
      "pre_order": false,
      "warningText": false
  },
  {
      "id": 44613586026660,  // You'll need to update with actual variant ID
      "dockType": "1x Monitor",
      "years": "2024",
      "model": "Pro",
      "sizes": "16",
      "processor": ["M4"],
      "pre_order": false,
      "warningText": false
  },
  {
      "id": 44613586223268,  // You'll need to update with actual variant ID
      "dockType": "2x Monitor",
      "years": "2024",
      "model": "Pro",
      "sizes": "16",
      "processor": ["M4"],
      "pre_order": false,
      "warningText": false
  },
  {
      "id": 44613585797284,  // You'll need to update with actual variant ID
      "dockType": "Single Dock",
      "years": "2024",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M4"],
      "sub_processor": ["Base"],
      "pre_order": false,
      "warningText": true
  },
  {
      "id": 44613585993892,  // You'll need to update with actual variant ID
      "dockType": "1x Monitor",
      "years": "2024",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M4"],
      "sub_processor": ["Base"],
      "pre_order": false,
      "warningText": true
  },
  {
      "id": 44716290244772,  // You'll need to update with actual variant ID
      "dockType": "2x Monitor M3",  // Note: You might want to update this to "2x Monitor M4" or similar
      "years": "2024",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M4"],
      "sub_processor": ["Base"],
      "pre_order": false,
      "warningText": false
  },
  // MacBook Air M4 13" entries
  {
    "id": 45405552509092,
    "dockType": "2x Monitor M1/M2",  // May want to update to reflect M4 compatibility
    "years": "2025",
    "model": "Air",
    "sizes": "13",
    "processor": ["M4"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586059428,
    "dockType": "1x Monitor",
    "years": "2025",
    "model": "Air",
    "sizes": "13",
    "processor": ["M4"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585862820,
    "dockType": "Single Dock",
    "years": "2025",
    "model": "Air",
    "sizes": "13",
    "processor": ["M4"],
    "pre_order": false,
    "warningText": false
  },
  
  // MacBook Air M4 15" entries
  {
    "id": 45405575217316,
    "dockType": "2x Monitor M1/M2",  // May want to update to reflect M4 compatibility
    "years": "2025",
    "model": "Air",
    "sizes": "15",
    "processor": ["M4"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613586092196,
    "dockType": "1x Monitor",
    "years": "2025",
    "model": "Air",
    "sizes": "15",
    "processor": ["M4"],
    "pre_order": false,
    "warningText": false
  },
  {
    "id": 44613585895588,
    "dockType": "Single Dock",
    "years": "2025",
    "model": "Air",
    "sizes": "15",
    "processor": ["M4"],
    "pre_order": false,
    "warningText": false
  },
  
  // 14-inch M5 entries
  {
      "id": 44613585797284,  // You'll need to update with actual variant ID
      "dockType": "Single Dock",
      "years": "2025",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M5"],
      "pre_order": false,
      "warningText": false
  },
  {
      "id": 44613585993892,  // You'll need to update with actual variant ID
      "dockType": "1x Monitor",
      "years": "2025",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M5"],
      "pre_order": false,
      "warningText": false
  },
  {
      "id": 44613586190500,  // You'll need to update with actual variant ID
      "dockType": "2x Monitor",
      "years": "2025",
      "model": "Pro",
      "sizes": "14",
      "processor": ["M5"],
      "pre_order": false,
      "warningText": false
  }
]

// ═══════════════════════════════════════════════════════════════
// BUNDLE ADAPTER CONFIGURATIONS
// Keyed by dockType (which already differentiates the bundle variants)
// ═══════════════════════════════════════════════════════════════

var bundle_adapter_configurations = {
  "Single Dock": {
    adapters: []  // No additional items
  },
  
  "1x Monitor": {
    adapters: [
      {
        productHandle: "adapter",
        name: "5-in-1 USB-C Hub",
        description: [
          "1× HDMI port (4K @ 30Hz)",
          "3× USB-A 3.0 ports",
          "1× USB-C Power Delivery (87W charging)"
        ]
      }
    ]
  },
  
  // Standard 2x Monitor bundle (Intel, M1/M2/M3/M4 Pro/Max)
  // Uses two separate HDMI adapters
  "2x Monitor": {
    adapters: [
      {
        productHandle: "9-in-1-usb-c-adapter",
        name: "9-in-1 USB-C Hub",
        description: [
          "1× HDMI port (4K @ 30Hz)",
          "2× USB-A 3.0 ports",
          "SD & microSD card readers",
          "Gigabit Ethernet port",
          "3.5mm Audio jack",
          "VGA port (HD @ 60Hz)",
          "USB-C Power Delivery (87W charging)"
        ]
      },
      {
        productHandle: "usb-c-to-hdmi-adapter",
        name: "USB-C to HDMI Adapter",
        description: [
          "1× HDMI port (4K @ 30Hz)",
          "Enables second external display"
        ]
      }
    ]
  },
  
  // Special M1/M2 2x Monitor bundle (M1/M2/M3/M4 Base & Air chips)
  // Uses 5-in-1 hub + External Graphics adapter
  "2x Monitor M1/M2": {
    adapters: [
      {
        productHandle: "adapter",
        name: "5-in-1 USB-C Hub",
        description: [
          "1× HDMI port (4K @ 30Hz)",
          "3× USB-A 3.0 ports",
          "1× USB-C Power Delivery (87W charging)"
        ]
      },
      {
        productHandle: "usb-c-or-usb-3-0-to-hdmi-adapter",
        name: "External Graphics Adapter",
        description: [
          "1× HDMI port (4K @ 30Hz)",
          "Extends single-monitor MacBooks to dual displays",
          "Software-enabled multi-display support"
        ]
      }
    ]
  },
  
  // M3 Base chip 2x Monitor bundle (uses External Graphics adapter)
  "2x Monitor M3": {
    adapters: [
      {
        productHandle: "adapter",
        name: "5-in-1 USB-C Hub",
        description: [
          "1× HDMI port (4K @ 30Hz)",
          "3× USB-A 3.0 ports",
          "1× USB-C Power Delivery (87W charging)"
        ]
      },
      {
        productHandle: "usb-c-or-usb-3-0-to-hdmi-adapter",
        name: "External Graphics Adapter",
        description: [
          "1× HDMI port (4K @ 30Hz)",
          "Extends single-monitor MacBooks to dual displays",
          "Software-enabled multi-display support"
        ]
      }
    ]
  }
};

// ═══════════════════════════════════════════════════════════════
// DOCKING STATION OVERVIEW SPECS
// ═══════════════════════════════════════════════════════════════

var docking_station_overview = {
  "Type A": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "96W charging via USB-C",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  },
  "Type B": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "96W charging via USB-C",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  },
  "Type C": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "Up to 140W charging via MagSafe",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  },
  "Type D": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "Up to 140W charging via MagSafe",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  },
  "Type E": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "Up to 140W charging via MagSafe",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  },
  "Type F": {
    benefits: [
      "2× USB-C ports (40 Gbps Thunderbolt 4)",
      "Up to 140W charging via MagSafe",
      "Space Gray alloy construction",
      "One-slide connection for instant setup"
    ],
    futureCompatibility: "Works with your current MacBook and future models with the same design"
  }
};
